import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 18L15 12L9 6",
		stroke: "#596180",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRight;
